<script setup>
import { useStoreStore } from '@stores/store'
import { computed } from 'vue'

import Button from '@components/global/button.vue'

const store = useStoreStore()
const props = defineProps(['product'])

const plusButtonDisabled = computed(() => props.product.quantity >= 10)
const minusButtonDisabled = computed(() => props.product.quantity <= 1)

function changeQuantity(delta) {
	let quantity = props.product.quantity + delta
	if (quantity > 0 && quantity <= 10) {
		store.updateCart({
			id: props.product.id,
			quantity: quantity,
		})
	}
}
function remove() {
	store.updateCart({
		id: props.product.id,
		quantity: 0,
	})
}
</script>

<template>
	<div class="flex items-center gap-4 uppercase">
		<div class="h-20 w-20 rounded-small border border-dashed border-sf-purple-base px-5 py-2">
			<img class="h-full w-full object-contain" :src="product.image" :alt="product.title" />
		</div>
		<div class="flex grow flex-col gap-3">
			<div class="flex items-center justify-between gap-2">
				<div class="flex flex-col gap-1">
					<div class="flex flex-col gap-1">
						<p class="font-body text-body-sm font-medium text-text-muted/50">{{ product.type }}</p>
						<h6 class="font-heading text-h6 font-semibold text-text-base">
							{{ product.title }}
						</h6>
					</div>
				</div>
				<Button class="remove" :without-edge="true" @click="remove" icon="fa-regular fa-trash-can text-sf-purple-base"></Button>
			</div>
			<div class="flex items-center justify-between">
				<div class="flex w-fit items-center rounded-full bg-bg-light p-1 text-text-base">
					<Button class="flex h-8 w-8 items-center justify-center disabled:opacity-30" :disabled="minusButtonDisabled" @click="changeQuantity(-1)" icon="fa-solid fa-minus"></Button>
					<div class="flex items-center px-5">
						<span>{{ product.quantity }}</span>
					</div>
					<Button class="flex h-8 w-8 items-center justify-center disabled:opacity-30" :disabled="plusButtonDisabled" @click="changeQuantity(+1)" icon="fa-solid fa-plus"></Button>
				</div>
				<p class="text-base font-bold">{{ product.price }}</p>
			</div>
		</div>
	</div>
</template>
